import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import getPath from 'lodash/get';

export const extractSoundcasts = (managed, condition = () => true) => {
  return Object.keys(managed).reduce((prev, id) => {
    const soundcast = managed[id];
    if (soundcast.title && condition(soundcast)) {
      prev.push({
        ...soundcast,
        id,
      });
    }

    return prev;
  }, []);
};

export const soundcastsManagedV2Selector = condition =>
  createSelector(
    state => getPath(state, 'managed.soundcasts.byId', {}),
    soundcastsManaged =>
      orderBy(extractSoundcasts(soundcastsManaged, condition), ['date_created'], 'asc')
  );

export const soundcastsManagedEpisodesSelector = () =>
  createSelector(
    [
      state => getPath(state, `managed.episodes.byId`, {}),
      (state, soundcastId) => getPath(state, `managed.episodes.bySoundcast.${soundcastId}`, []),
    ],
    (episodesById, episodesManaged) => episodesManaged.map(episodeId => episodesById[episodeId])
  );

export const managedEpisodeByIdSelector = () =>
  createSelector(
    (state, episodeId) => getPath(state, `managed.episodes.byId.${episodeId}`, {}),
    episode => episode
  );

export const episodesCountSelector = () =>
  createSelector(
    state => getPath(state, 'managed.soundcasts.byId', {}),
    soundcastsManaged =>
      Object.keys(soundcastsManaged).reduce((count, soundcastId) => {
        const soundcast = soundcastsManaged[soundcastId];
        if (isEmpty(soundcast)) {
          return count;
        }

        // make sure soundcast is not a `bundle`
        if ('bundle' in soundcast) {
          return count;
        }

        // episodes should be in soundcast
        if ('episodes' in soundcast) {
          count += Object.keys(soundcast.episodes).length;
        }

        return count;
      }, 0)
  );
